export default __webpack_public_path__ + "static/media/setting.28f2e0b1.svg";